import React from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, useTheme } from '@mui/material';
import { tokens } from '../../theme';

import AddCircleIcon from '@mui/icons-material/AddCircle';



export default function SkeletonTable() {
    const rows = Array.from({ length: 3 }); // Generate 7 rows for the skeleton
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    return (
        <Paper
            sx={{
                backgroundColor: '#72203b', // Matches the table background in your design
                padding: '16px',
                borderRadius: '8px',
                color: '#fff',
                width: '90%'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                }}
            >
                <Box sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#fff' }}>
                    Pagamentos
                </Box>
                <Button
                    startIcon={<AddCircleIcon size={24} color="inherit" />}
                    size="small"
                    color="success"
                    disabled
                    sx={{borderRadius:  '6px', color: 'whitesmoke'}}
                    variant="contained"
                >
                    Adicionar
                </Button>
            </Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>ID</TableCell>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Data</TableCell>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Valor</TableCell>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Observações</TableCell>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Editar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((_, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={20} height={20} />
                                </TableCell>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={80} height={20} />
                                </TableCell>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={50} height={20} />
                                </TableCell>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={150} height={20} />
                                </TableCell>
                                <TableCell align="center">
                                    <Skeleton variant="circular" width={20} height={20} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}